<div>
    <h2>{{'historico-designaciones.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-designaciones.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-designaciones.filters.campanya' | translate}}</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
                    [disabled]="disabledProvincias" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}} {{required ? ('*') : ('')}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-designaciones.filters.etiquetador' | translate}}</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-designaciones.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="desFinca">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-designaciones.filters.productor' | translate}}</label>
                <input type="text" formControlName="desProductor">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
        <i class="fas fa-file-pdf" [ngClass]="{'disabled': !historicoDesignaciones}"
            (click)="exportarPdfOrExcel('pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()"
            title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <!-- <section class="export-buttons">
        <i class="fas fa-file-pdf" [ngClass]="{'disabled': !historicoDesignaciones || (historicoDesignaciones && historicoDesignaciones.length < 1) || getRolePermission()}"
            title="{{'titles.exportarPDF' | translate}}"></i>
    </section> -->
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.HCJFechaIns', 2)">
                            {{'historico-designaciones.table.fecha' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.HCJFechaIns')"></i></div>
                        </th>
                        <th class="string">
                            {{'historico-designaciones.table.campanya' | translate}}
                        </th>
                        <!--
                        <th class="string sortable" (click)="toOrderBy('x=> x.denominacion', 4)">
                          {{'historico-designaciones.table.denominacion' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.denominacion')"></i></div>
                        </th> -->
                        <th class="string sortable" (click)="toOrderBy('$.DesEtiquetador', 5)">
                            {{'historico-designaciones.table.etiquetador' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.DesEtiquetador')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.DesMarca', 6)">
                            {{'historico-designaciones.table.marca' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.DesMarca')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.DesFinca', 7)">
                            {{'global.finca' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.DesFinca')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.LsDesProductor', 8)">
                            {{'historico-designaciones.table.productor' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.LsDesProductor')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.DesMunicipio', 9)">
                            {{'global.municipio' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.DesMunicipio')"></i></div>
                        </th>
                        <th class="number" *ngIf="this.role === 'Administrador' || this.claims.includes('D_HDS_AforoVisible')">
                            {{'historico-designaciones.table.aforo' | translate}}
                        </th>
                        <th class="number sortable" (click)="toOrderBy('x=> x.cantidad', indexOrder)">
                            {{'historico-designaciones.table.designado' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.cantidad')"></i></div>
                        </th>
                        <th class="action"></th>
                    </tr>
                </thead>
                <tbody *ngFor="let historico of historicoDesignaciones; let i = index; trackBy: trackByDesignacionId">
                    <tr (click)="showDetails(i)" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i
                                [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="date">{{historico.fecha | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="string">{{historico.anyoCampanya}}</td>
                        <!-- <td class="string">{{historico.desDenominacion}}</td> -->
                        <td class="string">{{historico.desEtiquetador}}</td>
                        <td class="string">{{historico.desMarca}}</td>
                        <td class="string">{{historico.desFinca}}</td>
                        <td class="string">{{historico.desProductor}}</td>
                        <td class="string">{{historico.desMunicipio}}</td>
                        <td class="number" *ngIf="this.role === 'Administrador' || this.claims.includes('D_HDS_AforoVisible')">
                            {{historico.aforoCultivo | number : '1.2-2': defaultLanguage}}</td>
                        <td class="number">{{historico.cantidad | number : '1.2-2': defaultLanguage}}</td>
                        <td class="actions">
                            <i class="fas fa-stream" app-click-stop-propagation (click)="showSection(i)"
                                title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="11">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                    <label>{{'historico-designaciones.table.id' | translate}}</label>
                                    <p>{{historico.designacionId}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-designaciones.table.denominacion' | translate}}</label>
                                    <p>{{historico.desDenominacion}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-designaciones.table.licencia' | translate}}</label>
                                    <p>{{historico.nLicencia}}</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="3">
                            <section class="tabs">
                                <ul>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 1}">
                                        {{'historico-designaciones.almacenes.titulo' | translate}}</li>
                                </ul>
                                <content>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th class="subtable id">{{'historico-designaciones.almacenes.id' | translate}}
                                                </th>
                                                <th class="subtable string">{{'global.almacen' |
                                                    translate}}</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let almacen of historico.almacenesDesignacion">
                                            <tr>
                                                <td class="id">{{almacen.item1}}</td>
                                                <td class="string">{{almacen.item2}}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot
                                            *ngIf="!historico.almacenesDesignacion || (historico.almacenesDesignacion && historico.almacenesDesignacion.length < 1)">
                                            <tr>
                                                <td colspan="2">
                                                    {{'global.noContent' | translate}}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </content>
                            </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!historicoDesignaciones || (historicoDesignaciones && historicoDesignaciones.length < 1)">
                    <tr>
                        <td colspan="11">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="historicoDesignaciones && historicoDesignaciones.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showError=$event; showWarning=$event">
    </app-toast>
</div>